<div class="input-group input-group-sm">
  <input [id]="input.MainElementList[0].ID" [attr.type]="input.MainElementList[0].Type" class="form-control q-bo-input q-bo-wrap" aria-label="Small" attr.aria-describedby="{{input.MainElementList[0].ID}}-btn"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input)">
  <div *ngFor="let button of input.MainElementList.slice(1)" class="input-group-append">
    <button *ngIf="button.Type === 'BUTTON'" class="btn btn-outline-secondary q-bo-inputbtn q-bo-wrap" (click)="navig(button, input.MainElementList[0].Value)">
      <i class="{{button.Src}}"></i>
    </button>
  </div>
</div>


<!--<div class="input-group input-group-sm">
  <input [id]="input.MainElementList[0].ID" [attr.type]="input.MainElementList[0].Type" class="h-100 form-control q-input-no-border"
         [disabled]="input.MainElementList[0].Disabled" aria-label="Small" aria-describedby="inputGroup-sizing-sm"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="{'q-input-required':input.MainElementList[0].Required === 'require',
         'q-input-novalid':input.MainElementList[0].Required === 'novalid',
         'input-disabled':input.MainElementList[0].Disabled}">
  <div *ngIf="input.MainElementList.length > 1" class="input-group-append">
    <button class="btn btn-outline-secondary q-input-icon buttonBo justify-content-end" id="inputGroup-sizing-sm"
            (click)="navig(input.MainElementList[1], input.MainElementList[0].Value)">
      <i [ngClass]="input.MainElementList[1].Src"></i>
    </button>
  </div>
</div>-->
